import React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  isShown: boolean

  onAddFieldClick(): void

  label?: string
  title?: string
  /** Positional spacing only — the button owns its own look. */
  className?: string
}

function WorkflowFormAddFieldButton({
  isShown,
  onAddFieldClick,
  label = Localization.translator.addNewValue,
  title,
  className,
}: IProps) {
  if (!isShown) return null

  return (
    <span
      className={classList({
        'tw:mb-[15px] tw:cursor-pointer tw:self-end tw:px-2.5 tw:text-body-md tw:text-primary': true,
        [className]: !!className,
      })}
      title={title ?? label}
      onClick={onAddFieldClick}
    >
      + {label}
    </span>
  )
}

export default observer(WorkflowFormAddFieldButton)
